<template>
        <div class="right_box">
            <div class="right_title">
                <div class="title">
                    {{ TitleName }}
                </div>
                <div class="btn_box">
                    <el-select v-model="value" placeholder="换届选举" style="width: 160px;height:35px;background:#eeeeee;">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="right_news_box">
                <div class="list_item" v-for="(item, index) in list" :key="index">
                    <div class="title_box">
                        <div class="icon_box">
                            <span class="iconfont icon-toupiao"></span>
                        </div>
                        <div class="title">
                            {{ item.voteTitle }}
                        </div>
                    </div>
                    <div class="info_box">
                        <div class="count items">
                            每人限投:  {{ item.voteContent }}
                        </div>
                        <div class="time items">
                            开始时间: {{  item.beginTime }}
                        </div>
                        <div class="time items">
                            结束时间: {{  item.endTime }}
                        </div>
                    </div>
                    <div class="chose_box">
                        <div class="chose_item" v-for="(user, inx) in item.voteUserData" :key="inx">
                            <div class="chose_left">
                                {{ user.brief }}
                            </div>
                            <div class="chose_right">
                                <div class="chose_btn_box" v-if="user.isVote == 1">
                                    <el-tag type="danger" @click="touPiao(item, user )" :disabled="item.shengyuCount == 0" >投票</el-tag>
                                </div>
                                <div class="desc" v-else>
                                    <el-tag type="success">已投</el-tag>
                                </div>
                            </div>
                        </div>
                        <!-- <el-radio-group v-model="item.choseValue" @change="choseChange">
                            <el-radio  :label="user.voteUserId" v-for="(user, inx) in item.voteUserData" :key="inx" :disabled="user.isVote == 0">
                                {{ user.brief }}
                            </el-radio>
                        </el-radio-group> -->
                       
                    </div>
                    <!-- <div class="btn_box">
                        <el-button :disabled="item.shengyuCount == 0">投票</el-button>
                    </div> -->
                </div>
            </div>
            <no-more v-if="list.length == 0 "></no-more>
            <!-- fenye -->
            <div class="page_box" style="text-align:right;" v-if="list && list.length">
                <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                @current-change="pageChange"
                :total="totalPage * pageSize">
                </el-pagination>
            </div>

        </div>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        data() {
            return {
                TitleName: "投票活动",
                options: [{
                value: '选项1',
                label: '黄金糕'
                }, {
                value: '选项2',
                label: '双皮奶'
                }, {
                value: '选项3',
                label: '蚵仔煎'
                }, {
                value: '选项4',
                label: '龙须面'
                }, {
                value: '选项5',
                label: '北京烤鸭'
                }],
                list: [],
                value: '',
                radio: "",
                pageNum: 1,
                pageSize: 10,
                totalPage: 0,
            }
        },
        computed: {
            ...mapGetters(['token'])
        },
        mounted() {
            this.getList()
        },
        methods: {
            // 会议详情
            showMeetingDetail () {
                this.$router.push("/MeetingDetail")
            },
            // 获取投票列表
            async getList () {
                let { token, pageNum, pageSize } = this 
                if ( this.token ) {
                    let res = await this.$axios.post("/lencon/pc/activity/voteList",{ token, pageNum, pageSize  })
                    if ( res.data.code == 1 ) {
                        this.list = res.data.data
                        this.totalPage = res.data.totalPage
                        this.list.forEach( el => {
                            el.choseValue = ""
                        })
                    }
                } else {
                    return this.$confirm( "您还未登陆,请登录后在操作!", "提示", {
                        confirmButtonText: "去登录",
                        cancelButtonText: "取消",
                        type: "warning"
                    })
                    .then( () => {
                        this.$router.push("/login")
                    })
                    .catch(() => {
                        this.$router.go(-1)
                    })
                }
            },
            // 页码变化
            pageChange ( e ) {
                console.log( e )
                this.page = e 
                this.getList()
            },
            // 选择变化
            choseChange ( e ) {
                console.log( e )
            },
            // 点击投票
            async touPiao (item, user ) {
                if ( item.shengyuCount == 0 ) {
                    return this.$message.success("您的投票次数已用完!")
                }
                let { token } = this 
                let { voteUserId } = user 
                let res = await this.$axios.post("/lencon/pc/activity/voting", { token, voteUserId  })
                if ( res.data.code == 1 ) {
                    this.$message.success( res.data.msg )
                    this.getList()
                } else {
                    this.$message.error( res.data.msg )
                    this.getList()
                }
            }
        }
    }
</script>

<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
}
</style>

<style lang="scss" scoped>

    .right_box {
        width: 924px;
        background-color: #fff;
        border-radius: 0 10px 10px 0;
        box-sizing: border-box;
        .right_title {
            font-size: 20px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #eeeeee;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .right_news_box {
            width: 100%;
            // margin-top: 40px;
            .list_item {
                width: 100%;
                padding-bottom: 40px;
                margin-top: 40px;
                border-bottom: 1px solid #eeeeee;
                .title_box {
                    display: flex;
                    align-items: center;
                    font-size: 18px;
                    .icon_box {
                        width: 26px;
                        height: 26px;
                        margin-right: 20px;
                        .iconfont {
                            font-size: 24px;
                            color: #2767c4 ;
                        }
                    }
                }
                .info_box {
                    display: flex;
                    padding-left: 46px;
                    font-size: 14px;
                    color: #5D5D5D;
                    line-height: 40px;
                    .count {
                        color: #2767c4 ;
                        
                    }
                    .items {
                        margin-right: 20px;
                    }
                }
                .chose_box {
                    padding-left: 46px;
                    width: 100%;
                    .chose_item {
                        width: 600px;
                        display: flex;
                        align-items:center;
                        border: 1px solid #b3b3b3;
                        margin: 20px 0;
                        padding: 10px;
                        justify-content: space-between;
                        border-radius: 5px;
                        .chose_right {
                            .el-tag{
                                cursor: pointer;
                            }
                        }
                    }
                }
                
            }
        }
    }

</style>